import StatusPill from 'components/StatusPill';
import { useHistoryBatch } from 'contexts/HistoryBatch';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate } from 'utils/formatDate';

export const HistoryBatchFile = () => {
  const { t } = useTranslation(['history', 'beneficiaries']);

  const { selectedFile } = useHistoryBatch();

  if (!selectedFile) return null;

  return (
    <div className="details-box">
      <strong>{t('load_name')}:</strong>
      <span>{selectedFile.filename}</span>
      <div>
        <span>
          <strong>{t('date')}: </strong>
          {formatDate(selectedFile.created)}
        </span>
        <span> | </span>
        <div className="status-wrapper">
          <strong>{t('status')}: </strong>
          <StatusPill status={selectedFile.status} selected summary />
        </div>
      </div>
    </div>
  );
};
